import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { capitalize, scrollWindowTo } from 'helpers';
import WP from 'WP';
import api from 'api';

import SkiPackageOrderInput from './SkiPackageOrderInput';
import ContactForm from './ContactForm';
import SuccessForm from './SuccessForm';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import Button from 'partials/Button';
import LoadingButton from 'partials/LoadingButton';

import Media from 'css/Media';

class RentalForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            personalia: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                adress: '',
                postalCode: '',
                city: '',
            },
            price: [],
            submitted: false,
            disabled: false,
            validated: false,
            products: {},
            date: null,
            dateValid: true,
            days: 1,
            message: '',
        }
    }


    //onChange for contact form text input
    handleOnChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({personalia: {...this.state.personalia, [name]: value}});
    }

    //onChange for ski package form text area
    handleTextAreaInputChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({ [name]: value });
    }

    //onChange for ski package form numDays input
    setDropdownValue = (e, name) => {
        this.setState({ [name]: e });
    }


    handleAddReservations = (product, index) => {
        if (index === undefined) index = 0;

        const products = {...this.state.products};
        let currentProduct = products[index];

        if (currentProduct === undefined) {
            currentProduct = product;
        } else {
            // merge.
            currentProduct.product = {...currentProduct.product, ...product.product};
            currentProduct.extraFields = {...currentProduct.extraFields, ...product.extraFields};
        }

        products[index] = currentProduct;

        this.setState({ products });
    };

    //onChange for date picker in ski package form
    setDate = dateObj => {
        let string = capitalize(moment(new Date(dateObj)).format('dddd D. MMM. YYYY,'));
        this.setState({date: dateObj, dateStr: string, dateValid: true})
    }

    // onSubmit field validation
    validateFields = () => {
        const { personalia, products, date} = this.state;

        let contact = document.getElementById('contact_form');
        let skiPackage = document.getElementById('ski_package_input');

        // if no products
        if (!Object.keys(products).length) {
            this.setState({submitting: false})
            window.scrollTo({
                top:  window.scrollY + skiPackage.getBoundingClientRect().top,
                left: 0,
                behavior: 'smooth'
            });
            return;
        }

        // if no date set
        if (!date) {
            this.setState({
                dateValid: false,
                submitting: false
            });
            window.scrollTo({
                top:  window.scrollY + skiPackage.getBoundingClientRect().top,
                left: 0,
                behavior: 'smooth'
            });
            return;
        }

        if (
            personalia.firstName.length > 0 &&
            personalia.lastName.length > 0 &&
            personalia.email.length > 0 &&
            personalia.phone.length > 0 &&
            personalia.adress.length > 0 &&
            personalia.postalCode.length > 0 &&
            personalia.city.length > 0
        ) {
            this.getPrice();
        } else {
            this.setState({submitting: false})
            window.scrollTo({
                top:  window.scrollY + contact.getBoundingClientRect().top,
                left: 0,
                behavior: 'smooth'
            });
        }
    };

    //Get total prices and summary before submit and api requests
    getPrice = () => {
        const { products, days } = this.state;

        let arr = [];
        for (let [idx, product] of Object.entries(products)) {
            arr.push(product)
        }

        let productArr = [];
        arr.map(product => {
            let item = product.product;
            let rental = {
                name: item.acf.title,
                rentalPrice: [],
                total: [],
                extraFields: product.extraFields || null,
            }
            
            if(item.acf.package_type === 'other') {
                rental.rentalPrice.push(parseInt(item.acf.day_rate));
                rental.total.push(parseInt(item.acf.day_rate));
                
                for(let i = 1; i < this.state.days; i++) {
                    rental.rentalPrice.push(parseInt(item.acf.day_rate_following));
                    rental.total.push(parseInt(item.acf.day_rate_following));
                }
            } else {
                for(let i = 0; i < this.state.days; i++) {
                    let date = new Date(this.state.date);
                    let targetDay = new Date(date);
                    targetDay.setDate(targetDay.getDate() + i);

                    let day = targetDay.toString().split("").splice(0,3).join("");
                    rental.rentalPrice.push(this.isWeekend(day, item, i));
                    rental.total.push(this.isWeekend(day, item, i));
                }
            }

            rental.rentalPrice = rental.rentalPrice.reduce((acc, num) => acc + num);
            rental.total = rental.total.reduce((acc, num) => acc + num);

            productArr.push(rental);
            return null;
        })
        this.setState({rentals: productArr},() => this.handleSubmit());
    };

    isWeekend = (day, product, i) => {
        if(day == 'Fri' || day == 'Sat' || day == 'Sun') {
            if(i === 0) {
                return parseInt(product.acf.price_weekends);
            } else return parseInt(product.acf.following_day_weekends_price);
            
        } else {
            if(i === 0) {
                return parseInt(product.acf.price_weekdays);
            } else return parseInt(product.acf.following_day_weekdays_price);
        }
    }

    handleSubmit = () => {
        api.sendSkiPackageRentalRequest({
            bookingEmail: this.props.booking_email,
            products: this.state.rentals,
            date: moment(new Date(this.state.date)).format('DD-MM-YYYY'),
            days: this.state.days,
            name: this.state.personalia.firstName + ' ' + this.state.personalia.lastName,
            email: this.state.personalia.email,
            phone: this.state.personalia.phone,
            adress: this.state.personalia.adress,
            postalCode: this.state.personalia.postalCode,
            city: this.state.personalia.city,
            message: this.state.message,

        }).then(resp => {
            if(resp.data) {
                this.setState({
                    submitted: true,
                    disabled: true
                })
                this.props.disableCards();
                this.sendOrderConfirmationMail();
                let form = document.getElementById('form');
                window.scrollTo({
                    top:  window.scrollY + form.getBoundingClientRect().top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    }

    sendOrderConfirmationMail = () => {
        api.sendSkiPackageRentalOrderConfirmation({
            email: this.state.personalia.email,
            products: this.state.rentals,
            date: moment(new Date(this.state.date)).format('DD-MM-YYYY'),
            days: this.state.days,
            name: this.state.personalia.firstName + ' ' + this.state.personalia.lastName,
            phone: this.state.personalia.phone,
            adress: this.state.personalia.adress,
            postalCode: this.state.personalia.postalCode,
            city: this.state.personalia.city,

        });
    }

    render() {
        const { form_title, form_text_content, products, defaultValue } = this.props;
        const {
            days,
            personalia,
            dateStr,
            rentals,
            submitting,
            submitted,
            disabled,
            validEmailFormat,
            dateValid
        } = this.state;

        return (
            <React.Fragment>
                { !submitted &&
                    <FormGrid id="form">
                        <TitleGridElement
                            id="skiPackage"
                            colStart={{default: 1, s: 3, m: 3}}
                            colEnd={{default: 8, s: 14, m: 14}}
                            rowStart={1}
                        >
                            <h4>{form_title}</h4>
                        </TitleGridElement>
                        <GridElement
                            colStart={{default: 1, s: 3, m: 3}}
                            colEnd={{default: 8, s: 14, m: 14}}
                            rowStart={2}
                        >
                            <SkiPackageOrderInput
                                products={products}
                                reservations={this.state.products}
                                handleAddReservations={this.handleAddReservations}
                                setDate={this.setDate}
                                handleOnChange={this.handleOnChange}
                                handleTextAreaInputChange={this.handleTextAreaInputChange}
                                setDropdownValue={this.setDropdownValue}
                                handleCheck={this.handleCheck}
                                days={days}
                                defaultValue={defaultValue}
                                dateValid={dateValid}
                            />
                        </GridElement>
                        <DividerGridElement
                            colStart={{default: 1, s: 1, m: 1}}
                            colEnd={{default: 8, s: 16, m: 16}}
                            rowStart={3}
                        />
                        <GridElement
                            id="contact_form"
                            colStart={{default: 1, s: 1}}
                            colEnd={{default: 8, s: 16}}
                            rowStart={4}
                        >
                            <ContactForm
                                personalia={personalia}
                                submitted={submitted}
                                handleOnChange={this.handleOnChange}
                                validateEmailFormat={this.validateEmailFormat}
                                validEmailFormat={validEmailFormat}
                            />
                        </GridElement>
                        { form_text_content &&
                            <HtmlGridElement
                                colStart={{default: 1, s: 3}}
                                colEnd={{default: 8, s: 14}}
                                rowStart={5}
                            >
                            <Html content>{form_text_content}</Html>
                        </HtmlGridElement>}
                        <InputGridElement
                            colStart={{default: 1, s: 5, m: 11}}
                            colEnd={{default: 4, s: 12, m: 14}}
                            rowStart={6}
                            align="center"
                        >
                            { submitting ?
                                <LoadingButton placeholder={WP.trans.sendRegistration} />
                                :
                                <Button 
                                    onClick={disabled ? null : () => this.validateFields()} 
                                    tabIndex={1}
                                >
                                    { submitted ? 
                                        WP.trans.thanks :
                                        WP.trans.sendRegistration
                                    }
                                </Button>
                            }
                        </InputGridElement>
                    </FormGrid>
                }
                { submitted &&
                    <SuccessForm 
                        date={dateStr}
                        days={days} 
                        rentals={rentals}
                        personalia={personalia}
                    />
                }
            </React.Fragment>
        )
    }
}


export default RentalForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        margin-bottom: ${props => props.theme.spacing.blockL};
        border: 1px solid ${props => props.theme.colors.text};
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementM};
    `}
`

const HtmlGridElement = styled(GridElement)`

    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXS};
    `}
`

const DividerGridElement = styled(GridElement)`
    width: 100%;
    padding-top: ${props => props.theme.spacing.elementL};
    margin-bottom: 0;

    ${Media.greaterThan('s')`
        border-bottom: 1px solid ${props => props.theme.colors.lines};
        padding-top: ${props => props.theme.spacing.blockS};
        margin-bottom: ${props => props.theme.spacing.blockS};
    `}
`

const InputGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementM};
        }
    `}
`